import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Emails, EmailService, EmailStateModel, Users } from '@harlowe/core';
import { EncounterDraftEmail, ReferralDraftEmail, TemplateEmail } from "@harlowe/core";
import { Injectable } from "@angular/core";
import { append, patch, removeItem, updateItem } from "@ngxs/store/operators";
import { EncounterService } from "../../services/encounter.service";
import { lastValueFrom } from "rxjs";
import { plainToInstance } from "class-transformer";
import { ReferralService } from "../../services/referral.service";
import { Encounters } from "../encounters/encounter-actions";


@State<EmailStateModel>
(
    {
        name: "email",
        defaults:
        {
            encounterDraftEmails: [],
            referralDraftEmails: [],
            receivedEmails: [],
            unreadReceivedEmails: [],
        }
    }
)

  @Injectable({ providedIn: 'root' })
  export class EmailState
  {
    constructor(private _emailService: EmailService, private _encounterService: EncounterService, private _referralService: ReferralService){}

    

    @Selector()
    static encounterDraftEmails(state: EmailStateModel)
    {
        return state.encounterDraftEmails.map(e => plainToInstance(EncounterDraftEmail, e));
    }

    @Selector()
    static referralDraftEmails(state: EmailStateModel)
    {
        return state.referralDraftEmails.map(e => plainToInstance(ReferralDraftEmail, e));
    }

    @Selector()
    static receivedEmails(state: EmailStateModel)
    {
        return state.receivedEmails;
    }

    @Selector()
    static unreadReceivedEmails(state: EmailStateModel)
    {
        return state.unreadReceivedEmails;
    }


    @Action(Users.UserLoggedIn)
    async userLoggedIn(ctx: StateContext<EmailStateModel>, action: Users.UserLoggedIn)
    {

        var eDrafts = await this._encounterService.getEncounterDraftEmails();
        var rDrafts = await this._referralService.getReferralDraftEmails();




        const state = ctx.getState();
        ctx.setState
        (
            { 
                ...state,
                encounterDraftEmails: eDrafts,
                referralDraftEmails: rDrafts,
                receivedEmails: await lastValueFrom(this._encounterService.getReceivedNoCategoryEmails()),
                unreadReceivedEmails: await lastValueFrom(this._encounterService.getEncounterUnreadReceivedEmails())
            }
        )
    }
    
    @Action([Emails.EmailServiceEncounterEmailDraftAdded, Emails.EmailServiceReferralEmailDraftAdded])
    emailAdded(ctx: StateContext<EmailStateModel>, action: Emails.EmailServiceEncounterEmailDraftAdded | Emails.EmailServiceReferralEmailDraftAdded)
    {   
        

        if (action instanceof Emails.EmailServiceEncounterEmailDraftAdded)
        {
            ctx.setState
            (
                patch<EmailStateModel>
                ({
                    encounterDraftEmails: append([action.payload.draftEmail])
                })
            );
        }
        else if (action instanceof Emails.EmailServiceReferralEmailDraftAdded)
        {
            ctx.setState
            (
                patch<EmailStateModel>
                ({
                    referralDraftEmails: append([action.payload.draftEmail])
                })
            )
        }
    
    }

    @Action([Emails.EmailServiceEmailDraftUpdated])
    async emailSaved(ctx: StateContext<EmailStateModel>, action: Emails.EmailServiceEmailDraftUpdated)
    {
        

        //See if the draft is in either of our lists
        const state = ctx.getState();

        if(state.encounterDraftEmails.map(e => e.id).includes(action.payload.draftEmail.id))
        {
            var encounterId = state.encounterDraftEmails.find(d => d.id == action.payload.draftEmail.id)?.encounterId;
            var eDraft = await this._encounterService.getEncounterDraftEmail(encounterId!,action.payload.draftEmail.id!);

            ctx.setState
            (
                patch
                (
                    { encounterDraftEmails: updateItem(draft => draft.id === eDraft.id, eDraft) }
                )
            )
        } 
        else if(state.referralDraftEmails.map(e => e.id).includes(action.payload.draftEmail.id))
        {
            var referralId = state.referralDraftEmails.find(d => d.id == action.payload.draftEmail.id)?.referralId;

            var rDraft = await this._referralService.getReferralDraftEmail(referralId!, action.payload.draftEmail.id!);

            ctx.setState
            (
                patch
                (
                    { referralDraftEmails: updateItem(draft => draft.id === rDraft.id, rDraft) }
                )
            )
        }
    }

    @Action([Emails.EmailServiceEmailDraftDeleted, Emails.EmailServiceEmailDraftSent], { cancelUncompleted: true })
    async emailDraftRemoved(ctx: StateContext<EmailStateModel>, action: Emails.EmailServiceEmailDraftDeleted | Emails.EmailServiceEmailDraftSent)
    {
        //The draft email is no longer in the lists...
        const state = ctx.getState();

        if(state.encounterDraftEmails.map(e => e.id).includes(action.payload.draftEmailId))
        {
            ctx.setState
            (
                patch<EmailStateModel> ({ encounterDraftEmails: removeItem(draft => draft.id == action.payload.draftEmailId) })
            )
        }
        else if(state.referralDraftEmails.map(e => e.id).includes(action.payload.draftEmailId))
        {
            ctx.setState
            (
                patch<EmailStateModel> ({ referralDraftEmails: removeItem(draft => draft.id == action.payload.draftEmailId)})
            )

            //Make sure we update the referral that has had a draft sent now
        }
    }


    @Action([Emails.EmailServiceEmailReceivedRead])
    async emailReceivedRead(ctx: StateContext<EmailStateModel>, action: Emails.EmailServiceEmailReceivedRead)
    {
        var receivedEmail = await lastValueFrom(this._encounterService.getEncounterUnreadReceivedEmail(action.payload.emailId));
        ctx.setState
        (
            patch<EmailStateModel> ({ unreadReceivedEmails: updateItem(draft => draft.id == action.payload.emailId, receivedEmail)})
        )
    }

    @Action(Encounters.EncounterServiceEncounterEmailReceived)
    emailReceived(ctx: StateContext<EmailStateModel>, action: Encounters.EncounterServiceEncounterEmailReceived)
    {
        ctx.setState
        {
            patch<EmailStateModel>
            ({
                unreadReceivedEmails: append([action.payload.email])
            })
        }
    }




    //@Action(Encounters.EncounterServiceEncounterEmailReceived)
    // emailReceived(ctx: StateContext<EmailStateModel>, action: Encounters.EncounterServiceEncounterEmailReceived)
    // {
    //     ctx.setState
    //     (
    //         patch<EmailStateModel>
    //         ({
    //             receivedEmails: removeItem(email => email.id == action.payload.email.id)
    //         })
    //     )
    // }

  }
